import React from 'react';
import PropTypes from 'prop-types';

const FormDeleteConfirmationModal = (props) => {
  const {
    onDelete,
    onCancel
  } = props;

  return (
    <div
      className="modal fade"
      id="deleteFormModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="deleteModalTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="deleteModalTitle">Archive form</h5>
          </div>
          <div className="modal-body">
            Are you sure you want to archive this form?
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              data-dismiss="modal"
              onClick={onDelete}
            >
              Archive
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

FormDeleteConfirmationModal.defaultProps = {
  onCancel: () => {}
};

FormDeleteConfirmationModal.propTypes = {
  onCancel: PropTypes.func,
  onDelete: PropTypes.func.isRequired
};

export default FormDeleteConfirmationModal;
